import React, {Component} from 'react';
import {LevelTrackerComponent} from "../StudentsComponent/Common";


const customStyle = {
    maxWidth: "8px",
    padding: "5px 10px",
    margin: "0 2px",
};

class ScoreBox extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className={"container"} style={{width: "100%"}}>
                {this.props.app && this.props.app === "slash" ?
                    <div className={"row"}>
                        <h4>Correct<span style={customStyle} className="blankSpace correct">{this.props.correct}</span> Wrong<span style={customStyle} className="blankSpace error">{this.props.incorrect}</span>
                            {/*- Missed<span style={customStyle} className="blankSpace">{this.props.skipped}</span>*/}
                            {/*= Score<span style={customStyle} className="blankSpace correct">{this.props.score}</span>*/}
                        </h4>
                    </div>
                    : null
                }
                {!this.props.app || this.props.app !== "slash" ?
                    <div className={"row"}>
                        <h4>Correct<span style={customStyle} className="blankSpace correct">{this.props.correct}</span> Wrong<span style={customStyle} className="blankSpace error">{this.props.incorrect}</span>
                            {/*= Score<span style={customStyle} className="blankSpace correct">{this.props.score}</span>*/}
                        </h4>

                        {/*<h3>Skipped <span style={customStyle} className="blankSpace">{this.props.skipped}</span></h3>*/}
                    </div>
                    : null
                }
            </div>
        );
    }
}

export default ScoreBox;



// WEBPACK FOOTER //
// ./src/ProgressModalComponent/ScoreBox.js